// Tamil Hindu Panchangam Muhurtham (auspicious wedding) dates.
// Source: drikpanchang.com / astroyogi / weddingwire / radhakrishnatemple panchangam compilations.
// Stored as 'YYYY-MM-DD' strings so they can be compared directly to <input type="date"> values.
// To extend / refresh, simply append new ISO dates per year — admin-configurable variant is TODO.

export const MUHURTHAM_DATES_2026 = [
  // January
  '2026-01-28', '2026-01-29', '2026-01-30', '2026-01-31',
  // February
  '2026-02-06', '2026-02-08', '2026-02-13', '2026-02-15',
  // March
  '2026-03-05', '2026-03-06', '2026-03-08', '2026-03-15', '2026-03-16',
  // April
  '2026-04-06', '2026-04-12', '2026-04-13', '2026-04-16', '2026-04-20', '2026-04-23', '2026-04-30',
  // May
  '2026-05-08', '2026-05-13', '2026-05-14', '2026-05-18', '2026-05-24', '2026-05-25',
  // June
  '2026-06-04', '2026-06-07', '2026-06-17', '2026-06-18', '2026-06-24', '2026-06-25',
  // July
  '2026-07-02', '2026-07-05', '2026-07-12',
  // August
  '2026-08-23', '2026-08-30', '2026-08-31',
  // September
  '2026-09-07', '2026-09-13', '2026-09-17',
  // October
  '2026-10-25', '2026-10-30',
  // November
  '2026-11-01', '2026-11-11', '2026-11-13', '2026-11-15', '2026-11-16',
  // December
  '2026-12-04', '2026-12-06', '2026-12-10', '2026-12-13', '2026-12-14',
];

// Aggregated lookup across all years. Add 2027/2028 lists here as they become available.
const ALL_MUHURTHAM_DATES = new Set([
  ...MUHURTHAM_DATES_2026,
]);

/**
 * Returns true when the given Date object falls on a known muhurtham day.
 */
export const isMuhurthamDate = (date) => {
  if (!date) return false;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return ALL_MUHURTHAM_DATES.has(`${y}-${m}-${d}`);
};

/**
 * Returns an array of JS Date objects for every muhurtham day — useful as the
 * `modifiers.muhurtham` value passed to react-day-picker.
 */
export const getMuhurthamDateObjects = () =>
  Array.from(ALL_MUHURTHAM_DATES).map((iso) => {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(y, m - 1, d);
  });

export default {
  isMuhurthamDate,
  getMuhurthamDateObjects,
  MUHURTHAM_DATES_2026,
};
